/**
 * Algolia Custom Hooks - Pastor Rick's Daily Hope
 */

document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteOptions",
    function (options) {
      // Enable empty search on focus
      options.openOnFocus = true;
      
      // Update placeholder text
      options.placeholder = "Search for products";
      
      return options;
    }
  );
});

document.addEventListener('algolia.hooks.initialize', function() {

  // Only customize the stats display
  algoliaShopify.hooks.registerHook('beforeInstantSearchStatsTemplate', function(_defaultTemplate, data, html) {
    const count = data.nbHits || 0;
    return html`<span class="boost-stats">${count} ${count === 1 ? 'product' : 'products'}</span>`;
  });

});

// Change "Search result" to "Search results" after page loads
document.addEventListener('DOMContentLoaded', function() {
  
  function getSearchQuery() {
  const urlParams = new URLSearchParams(window.location.search);
  const queryFromUrl = urlParams.get('q') || urlParams.get('query');
  if (queryFromUrl) return queryFromUrl;
  
  const algoliaInput = document.querySelector('.ais-SearchBox-input, .ais-input input, input[name="q"]');
  if (algoliaInput && algoliaInput.value) return algoliaInput.value;
  
  return '';
}

function updateTitle() {
  const titleElement = document.querySelector('.ais-page h1, .ais-page .ais-h2');
  if (titleElement) {
    const query = getSearchQuery();
    const currentText = titleElement.textContent || '';
    
    // Build the expected title
    const expectedTitle = query ? 'Search results for "' + query + '"' : 'Search results';
    
    // Only update if the title is NOT already correct (prevents infinite loop)
    if (currentText.trim() !== expectedTitle) {
      // Only change from default Algolia titles
      if (currentText.trim() === 'Search result' || 
          currentText.trim() === 'Search results' ||
          currentText.trim().startsWith('Search results for')) {
        titleElement.textContent = expectedTitle;
      }
    }
  }
}
  
  // Initial updates
  setTimeout(updateTitle, 100);
  setTimeout(updateTitle, 500);
  setTimeout(updateTitle, 1000);
  
  // Watch for Algolia re-renders
  setTimeout(function() {
    const titleElement = document.querySelector('.ais-page h1, .ais-page .ais-h2');
    if (titleElement) {
      const observer = new MutationObserver(function() {
        updateTitle();
      });
      
      observer.observe(titleElement, { 
        childList: true, 
        characterData: true, 
        subtree: true 
      });
    }
    
    // Initialize facet dropdown functionality
    initFacetDropdowns();
  }, 200);
});

// Facet dropdown functionality
function initFacetDropdowns() {
  const facetWrappers = document.querySelectorAll('.ais-facet-dropdown-wrapper');
  
  facetWrappers.forEach(function(wrapper) {
    const header = wrapper.querySelector('.ais-facet--header, .ais-range-slider--header');
    const container = wrapper.querySelector('.ais-facet-dropdown-container');
    
    if (header && container) {
      // Click handler for the header
      header.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const isCurrentlyOpen = container.classList.contains('is-open');
        
        // Close all other dropdowns first
        document.querySelectorAll('.ais-facet-dropdown-container.is-open').forEach(function(openContainer) {
          openContainer.classList.remove('is-open');
        });
        
        // Toggle this dropdown
        if (!isCurrentlyOpen) {
          container.classList.add('is-open');
        }
      });
    }
  });
  
  // Close dropdowns when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.ais-facet-dropdown-wrapper')) {
      document.querySelectorAll('.ais-facet-dropdown-container').forEach(function(container) {
        container.classList.remove('is-open');
      });
    }
  });
}

// Initialize panel close button when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  initPanelCloseButton();
});

function initPanelCloseButton() {
  // Watch for the panel to appear
  const observer = new MutationObserver(function(mutations) {
    const panel = document.querySelector('.aa-Panel');
    if (panel && !panel.querySelector('.aa-Panel-close')) {
      addPanelCloseButton(panel);
    }
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
}

function addPanelCloseButton(panel) {
  // Prevent duplicate buttons
  if (panel.querySelector('.aa-Panel-close')) {
    return;
  }
  
  const closeButton = document.createElement('button');
  closeButton.className = 'aa-Panel-close';
  closeButton.setAttribute('type', 'button');
  closeButton.setAttribute('aria-label', 'Close search panel');
  closeButton.innerHTML = `
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  `;
  
  closeButton.addEventListener('mousedown', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const input = document.querySelector('.aa-Input');
    
    // Method 1: Simulate clicking outside by clicking on the body
    document.body.click();
    
    // Method 2: Blur the input
    if (input) {
      input.blur();
    }
    
    // Method 3: Directly hide the panel
    panel.setAttribute('hidden', 'true');
    
    // Method 4: Simulate Escape key press
    const escapeEvent = new KeyboardEvent('keydown', {
      key: 'Escape',
      code: 'Escape',
      keyCode: 27,
      which: 27,
      bubbles: true
    });
    if (input) {
      input.dispatchEvent(escapeEvent);
    }
    document.dispatchEvent(escapeEvent);
  });
  
  panel.insertBefore(closeButton, panel.firstChild);
}


// ============================================
// MOBILE SEARCH - TRIGGER ALGOLIA DETACHED PANEL
// ============================================

(function() {
  'use strict';
  
  let initialized = false;
  
  function initMobileAlgoliaSync() {
    if (initialized) return;
    
    const algoliaButton = document.querySelector('.aa-DetachedSearchButton');
    if (!algoliaButton) {
      setTimeout(initMobileAlgoliaSync, 500);
      return;
    }
    
    initialized = true;
    console.log('Initializing mobile search capture...');
    
    // Capture phase listener - runs BEFORE theme's delegated handlers
    document.addEventListener('click', function(e) {
      const searchIcon = e.target.closest('a.js-search-form-open.mobile-only[href="/search"]');
      
      if (searchIcon) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        console.log('Intercepted search icon click, opening Algolia...');
        algoliaButton.click();
        return false;
      }
    }, true); // TRUE = capture phase, runs first
    
    console.log('Mobile search capture initialized');
  }
  
  // Initialize as early as possible
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileAlgoliaSync);
  } else {
    initMobileAlgoliaSync();
  }
  
})();